module.exports = __webpack_public_path__ + "static/media/VisitProfile.1f5b084f.svg";